var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappCarousel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9384 50.1134H58.6922M25.3661 30.0001H58.6922M33.4645 9.88672H3.30762M58.6922 9.88672H50.9384M3.30762 50.1134H33.4645",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4938 45.4259C38.7435 45.4259 36.5141 47.6554 36.5141 50.4057C36.5141 53.156 38.7435 55.3854 41.4938 55.3854C44.2441 55.3854 46.4736 53.156 46.4736 50.4057C46.4736 47.6554 44.2441 45.4259 41.4938 45.4259ZM31.8987 50.4057C31.8987 45.1064 36.1945 40.8105 41.4938 40.8105C46.7931 40.8105 51.089 45.1064 51.089 50.4057C51.089 55.705 46.7931 60.0008 41.4938 60.0008C36.1945 60.0008 31.8987 55.705 31.8987 50.4057Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.842 25.0207C13.0917 25.0207 10.8622 27.2501 10.8622 30.0004C10.8622 32.7507 13.0917 34.9802 15.842 34.9802C18.5922 34.9802 20.8217 32.7507 20.8217 30.0004C20.8217 27.2501 18.5922 25.0207 15.842 25.0207ZM6.24683 30.0004C6.24683 24.7011 10.5427 20.4053 15.842 20.4053C21.1412 20.4053 25.4371 24.7011 25.4371 30.0004C25.4371 35.2997 21.1412 39.5956 15.842 39.5956C10.5427 39.5956 6.24683 35.2997 6.24683 30.0004Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4938 4.61538C38.7435 4.61538 36.5141 6.8449 36.5141 9.59514C36.5141 12.3454 38.7435 14.5749 41.4938 14.5749C44.2441 14.5749 46.4736 12.3454 46.4736 9.59514C46.4736 6.8449 44.2441 4.61538 41.4938 4.61538ZM31.8987 9.59514C31.8987 4.29591 36.1945 0 41.4938 0C46.7931 0 51.089 4.29591 51.089 9.59514C51.089 14.8944 46.7931 19.1903 41.4938 19.1903C36.1945 19.1903 31.8987 14.8944 31.8987 9.59514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappCarousel2);
export default __webpack_public_path__ + "static/media/whatsapp-carousel-2.8aa0b92c4c1987b422e847803329cb83.svg";
export { ForwardRef as ReactComponent };